import { createAction, createReducer } from '@reduxjs/toolkit';
import { descend, prop, sort } from 'ramda';
import type { PaymentListResponseItem } from 'reactApp/api/billing/PaymentsAPICall';

import type { PaymentItem, State } from './payments.types';

const initialState: State = {
    list: [],
};

export const paymentsRequest = createAction('@payments/request');
export const paymentsSuccess = createAction<{ data: PaymentListResponseItem[] }>('@payments/success');
export const paymentsFailure = createAction<string>('@payments/failure');

export function convetPaymentResponseItem(item: PaymentListResponseItem): PaymentItem {
    return {
        amount: item.amount,
        time: item.ctime * 1000,
        currency: item.currency,
        paymentId: item.payment_id,
        productId: item.product,
        receiptType: item.receipt_type,
        receiptUrl: item.receipt_url,
        status: item.status,
        subscriptionId: item.sub_id,
        type: item.type,
    };
}

export const paymentsReducer = createReducer(initialState, {
    [paymentsSuccess.type]: (state, action: ReturnType<typeof paymentsSuccess>): void => {
        state.list = sort(descend(prop('time')), action.payload.data.map(convetPaymentResponseItem));
    },
});
